module.exports = __webpack_public_path__ + "img/arbor_place.png";